export default "https://cdn-static-staging.gokick.com/assets/44c43e25e1d60214daaa18ce4b143b941a81a79a/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";